export default __webpack_public_path__ + "static/media/imessage.8a205f6f.png";